import { copyTest } from '@coursera-web/copy-test';

import type { ExpressionOfInterestTextProps } from 'bundles/expression-of-interest/types';
import type { LandingPageEoiFieldsFragment } from 'bundles/xddp/__generated__/contentfulTypes';

const createEOICopyTest = (
  expressionOfInterest?: LandingPageEoiFieldsFragment,
  slug?: string
): ExpressionOfInterestTextProps | undefined => {
  if (!expressionOfInterest || !slug) return expressionOfInterest;
  const { applyButtonText, emailMeButtonText, programInterestText } = expressionOfInterest;
  return {
    ...(expressionOfInterest as LandingPageEoiFieldsFragment),
    applyButtonText: copyTest(`contentful-xddp-eoi-applyButtonText-${slug}-en`, applyButtonText),
    emailMeButtonText: copyTest(`contentful-xddp-eoi-emailMeButtonText-${slug}-en`, emailMeButtonText),
    programInterestText: copyTest(`contentful-xddp-eoi-programInterestText-${slug}-en`, programInterestText),
  };
};

export default createEOICopyTest;
